export default __webpack_public_path__ + "static/media/Logo.afb16b73.png";